import { render, staticRenderFns } from "./business-tabs.vue?vue&type=template&id=2795d464&scoped=true&"
import script from "./business-tabs.vue?vue&type=script&lang=js&"
export * from "./business-tabs.vue?vue&type=script&lang=js&"
import style0 from "./business-tabs.vue?vue&type=style&index=0&id=2795d464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795d464",
  null
  
)

export default component.exports